import { WidgetCustomizationActionCreateAttributes } from "~/api/Api";

/**
 * A WidgetCustomizationAction is "site-level" when it targets the entire site
 * rather than a specific page or a specific set of customizations — i.e. it
 * carries neither a `page_id` nor a non-empty `ids[]`.
 */
export const isSiteLevelWidgetCustomizationAction = (
  data: WidgetCustomizationActionCreateAttributes,
): boolean => !data.page_id && !data.ids?.length;
